'use client';

import { Skeleton } from '@pie/amber';
import { getCuratedStatus } from '@/hooks/usePolicy';
import { usePolicyPaymentPlans } from '@/hooks/usePolicyPaymentPlan';
import { useSearchPolicies } from '@/hooks/useSearchPolicies';
import { getQueriesSummary } from '@/utils/getQueriesSummary';
import { buildDescription, type PolicySummary } from './buildDescription';

export const HomePageDescription = () => {
  const policiesQuery = useSearchPolicies();
  const policyIds = policiesQuery.data?.results.map((p) => p.policyId) ?? [];
  const planQueries = usePolicyPaymentPlans(policyIds);
  const planQueriesSummary = getQueriesSummary(planQueries);

  if (policiesQuery.status === 'pending' || planQueriesSummary.status === 'pending') {
    return (
      <Skeleton
        className="w-full"
        onContrast
        size="body-sm"
        data-testid="home-description-skeleton"
      />
    );
  }

  if (policiesQuery.status === 'error' || planQueriesSummary.status === 'error') return null;

  const policies: PolicySummary[] = policiesQuery.data.results.map((p) => {
    const planQuery = planQueries.find((query) => query.data?.policyId === p.policyId);

    return {
      curatedStatus: getCuratedStatus(p),
      effectiveDate: p.effectiveDate,
      plan: planQuery?.data,
      policyId: p.policyId,
    };
  });

  return <>{buildDescription(policies)}</>;
};
